import {
  createViewEventElement,
  PageViewEvent,
  ProductSelectEvent,
  SearchUpdateEvent
} from 'https://cdn.shopify.com/storefront/standard-events.js';

if ('customElements' in window && !customElements.get('taksh-view-event')) {
  customElements.define('taksh-view-event', createViewEventElement());
}

document.addEventListener('taksh:product-select', function (event) {
  var detail = event.detail;
  if (!detail || !detail.product || !Array.isArray(detail.selectedOptions)) return;
  var deferred = ProductSelectEvent.createPromise();
  event.target.dispatchEvent(new ProductSelectEvent({
    product: detail.product,
    selectedOptions: detail.selectedOptions,
    promise: deferred.promise,
    detail: { source: 'taksh-variant-picker' }
  }));
  deferred.resolve({ variant: detail.variant || null });
});

function dispatchPageView() {
  document.dispatchEvent(new PageViewEvent({
    page: {
      template: document.body.getAttribute('data-template') || '',
      title: document.title,
      url: window.location.href
    }
  }));
}

function dispatchRenderedSearch() {
  document.querySelectorAll('[data-search-event]').forEach(function (form) {
    var query = form.getAttribute('data-search-query') || '';
    var totalCount = parseInt(form.getAttribute('data-search-count'), 10);
    if (!query || !Number.isFinite(totalCount)) return;
    var deferred = SearchUpdateEvent.createPromise();
    form.dispatchEvent(new SearchUpdateEvent({
      search: { query: query },
      promise: deferred.promise,
      detail: { source: 'taksh-search-results' }
    }));
    deferred.resolve({ totalCount: totalCount });
  });
}

function dispatchInitialEvents() {
  dispatchPageView();
  dispatchRenderedSearch();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dispatchInitialEvents, { once: true });
} else {
  dispatchInitialEvents();
}
